import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}

const SvgComponent = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            d="M2 9.59 10.607.983l1.414 1.414-8.607 8.607H11v2H0v-11h2v7.585Z"
            fill="currentColor"
        />
    </svg>
);

export default SvgComponent;
